module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "choice_brand mt20 mb20"
  }, [_c('div', {
    staticClass: "add_name"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandEnname))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌介绍：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("重点商品：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandGoodsDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌合作品类：")]), _vm._v(" "), _vm._l((_vm.brandDetail.supplierApplyBrandCategories), function(category) {
    return _c('span', {
      staticClass: "f999 f12"
    }, [_vm._v(_vm._s(category.categoryName) + ";  ")])
  })], 2)]), _vm._v(" "), (_vm.brandDetail.categoryIsBook != 1) ? _c('div', [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.brandDetail,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品是否进口："
    }
  }, [(_vm.brandDetail.goodsType == 1) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("非进口")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("进口")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌经营方式："
    }
  }, [(_vm.brandDetail.businessType == 1) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("自有品牌")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 2) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("代理商")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 3) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("其他")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 4) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("课程")]) : _vm._e()]), _vm._v(" "), (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "商标注册证电子版：",
      "prop": "trademarkRegistrationCertificateFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.trademarkRegistrationCertificateFile.split(',')), function(rcFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "完整授权链证书电子版：",
      "prop": "authCertificateFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.authCertificateFile.split(',')), function(acFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": acFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "订货单电子版：",
      "prop": "purchaseOrderFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.purchaseOrderFile.split(',')), function(poFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": poFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.brandDetail.customsDeclarationFormFile.split(',').length > 0 && _vm.brandDetail.customsDeclarationFormFile.split(',')[0] != '')),
      expression: "(brandDetail.customsDeclarationFormFile.split(',').length > 0 && brandDetail.customsDeclarationFormFile.split(',')[0]!='')"
    }],
    attrs: {
      "label": "报关单扫描件：",
      "prop": "customsDeclarationFormFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.customsDeclarationFormFile.split(',')), function(cdfFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": cdfFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.registeredCountry == 1 && _vm.brandDetail.goodsType == 1 && (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检单电子版：",
      "prop": "qualityInspectionFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.qualityInspectionFile.split(',')), function(qiFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": qiFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.brandDetail.inspectionQuarantineFile.split(',').length > 0 && _vm.brandDetail.inspectionQuarantineFile.split(',')[0] != '')),
      expression: "(brandDetail.inspectionQuarantineFile.split(',').length > 0 && brandDetail.inspectionQuarantineFile.split(',')[0]!='')"
    }],
    staticClass: "dib",
    attrs: {
      "label": "入境货物检验检疫证明：",
      "prop": "inspectionQuarantineFile"
    }
  }, [_c('div', _vm._l((_vm.brandDetail.inspectionQuarantineFile.split(',')), function(iqFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": iqFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.registeredCountry == 1 && _vm.brandDetail.goodsType == 1 && (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检日期：",
      "prop": "qualityInspectionDate"
    }
  }, [_vm._v("\n          \t" + _vm._s(_vm._f("time")(_vm.brandDetail.qualityInspectionDate)) + "\n          ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w60 auto mt120"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("品牌详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408f517e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/brandDetail.vue
// module id = 517
// module chunks = 0